function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = _has;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_has.js
// module id = 119
// module chunks = 168707334958949